import {ARCHIVE_PAGINATION_PAGE} from "../constants";

export default function setPagination(data, filterElement) {
    if (filterElement.hasAttribute(ARCHIVE_PAGINATION_PAGE)) {
        data.page_number = filterElement.getAttribute(ARCHIVE_PAGINATION_PAGE)
    }

    return data
}